import angular = require("angular");
import TPL = require("templates");

export class FooterDirective {

  scope;
  template;

  constructor(session) {
    this.template = TPL.navigationDirectives.footer;
    this.scope = (scope)=> {
        scope.vm = {
          session: session
        };
    }
  }

  static factory() {
    var tmp = (a) => new FooterDirective(a);
    tmp.$inject = ["session"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/footer.ts
 **/